import axios from "@/api/axiosInstance";
import { GetCatalogRequest, GetCatalogResponse } from "./types";

// Member-facing published-course catalog. Accepts an optional AbortSignal so
// callers can cancel an in-flight request when the search/filters change or a
// new infinite-scroll page is requested.
export const getCatalog = async (
  params: GetCatalogRequest,
  signal?: AbortSignal,
): Promise<GetCatalogResponse> => {
  const response = await axios.get<GetCatalogResponse>(
    "/api/private/learning-center/catalog",
    { params, signal },
  );
  return response.data;
};
